module.exports = __webpack_public_path__ + "static/media/13.e51519c3.webp";